import { setUrl, setBtnSmallVm, setBtnVw, setInfoBtnVW, setDrawerIsOpen, setMainLogo } from './drawerMenu';

export const setUrlThunk = (value) => {
    return async( dispatch ) => {
        sessionStorage.setItem('urlReturn', value);
        dispatch( setUrl(value) );
        return value;
    }
}
export const setBtnSmallVmThunk = (value) => {
    return async(dispatch) => {
        dispatch( setBtnSmallVm(value) );
        return value;
    }
}
export const setBtnVwThunk = (value) => {
    return async(dispatch) => {
        dispatch( setBtnVw(value) );
        return value;
    }
}
export const setInfoBtnVWThunk = (value) => {
    return async(dispatch) => {
        dispatch( setInfoBtnVW(value) );
        return value;
    }
}
export const setDrawerIsOpenThunk = (value) => {
    return async( dispatch ) => {
        dispatch( setDrawerIsOpen(value) );
        return value;
    }
}

export const setMainLogoThunk = (value) => {
    return async( dispatch ) => {
        dispatch( setMainLogo(value) );
        return value;
    }
}
